/**
 * @desc 查询中台库存
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockSkuPageListQry, options?: any) {
  return updateResponse(
    http(URL + `/stock/page`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
